<mat-card class="summary-card">
  <mat-card-header>
    <mat-card-title>Resumen de la Temporada</mat-card-title>
  </mat-card-header>

  <mat-card-content>

    <div *ngIf="stats; else noStats" class="kpi-grid">

      <div class="kpi-item">
        <span class="kpi-value">{{ stats.total_matches }}</span>
        <span class="kpi-label">Partidos</span>
      </div>

      <div class="kpi-item">
        <span class="kpi-value green">{{ stats.wins }}</span>
        <span class="kpi-label">Victorias</span>
      </div>

      <div class="kpi-item">
        <span class="kpi-value yellow">{{ stats.draws }}</span>
        <span class="kpi-label">Empates</span>
      </div>

      <div class="kpi-item">
        <span class="kpi-value red">{{ stats.losses }}</span>
        <span class="kpi-label">Derrotas</span>
      </div>

      <div class="kpi-item">
        <span class="kpi-value">{{ stats.goals_for }}</span>
        <span class="kpi-label">Goles a Favor</span>
      </div>

      <div class="kpi-item">
        <span class="kpi-value">{{ stats.goals_against }}</span>
        <span class="kpi-label">Goles en Contra</span>
      </div>

    </div>

    <ng-template #noStats>
      <div class="no-stats-container">
        <mat-icon>leaderboard</mat-icon>
        <span>No hay un resumen de estadísticas disponible para esta temporada.</span>
      </div>
    </ng-template>

  </mat-card-content>
</mat-card>
